<template>
  <span
    v-if="value !== null"
    :style="style"
    class="pass-rate"
    :class="
      baselineColumn && baselineColumn.baseline != null
        ? `color-${baselineResult(value, baselineColumn.baseline, baselineColumn.improvement)}`
        : ''
    "
  >
    {{ (value * 100).toFixed(2) }}%
  </span>
  <span v-else>-</span>
</template>

<script>
import _isNumber from 'lodash/isNumber';

export default {
  name: 'PassRate',
  props: {
    value: {
      required: true,
      validator(val) {
        return val === null || _isNumber(val);
      },
    },
    fail: {
      type: Boolean,
      required: false,
      default: false,
    },
    baselineColumn: {
      type: Object,
      required: false,
      default: null,
    },
  },
  computed: {
    styleVal() {
      return this.fail ? 1.0 - this.value : this.value;
    },
    style() {
      if (this.baselineColumn && this.baselineColumn.baseline != null) {
        return {
          borderBottomColor: this.baselineResult(
            this.styleVal,
            this.baselineColumn.baseline,
            this.baselineColumn.improvement,
          ),
        };
      }
      let color = 'var(--pass)';
      if (this.styleVal < 0.995) {
        color = 'var(--warn)';
      }
      if (this.styleVal < 0.95) {
        color = 'var(--fail)';
      }
      return {
        borderBottomColor: color,
      };
    },
  },
  methods: {
    baselineResult(val, baseline, improvement = 'high') {
      if (baseline === null) return '';
      const [v, b] = improvement === 'high' ? [val, baseline] : [1 - val, 1 - baseline];
      if (v >= b) return 'pass';
      if (v < b * 0.95) return 'fail';
      return 'warn';
    },
  },
};
</script>

<style scoped>
.pass-rate {
  border-bottom-width: 2px;
  border-bottom-style: solid;
  /* padding-bottom: 3px; */
}
</style>
